// extracted by mini-css-extract-plugin
export default {"root":"PlasmicMilestoneHeader_root__83pqr","text":"PlasmicMilestoneHeader_text__8aTHw","closeButton":"PlasmicMilestoneHeader_closeButton__ZD9Sc"};